module.exports = __webpack_public_path__ + "images/7e7f327a7294ea9ab8d1c488dae1d759.jpg";